<template lang="pug">
  #filters
    v-container.pb-0
      v-layout#dropdown.dropdown(row wrap justify-space-around)
        v-flex.mb-25(xs12 sm3 md2 mx-2)
          label.filter-label Estado
          v-autocomplete(
            :items="states"
            v-model="selectState"
            target="#dropdown"
            clearable
            solo
            flat
            label="Todos"
          )

        v-flex.mb-25(xs12 sm3 md1)
          label.filter-label Sexo
          v-select(
            :items="sexOptions"
            v-model="selectSex"
            target="#dropdown"
            solo
            clearable
            flat
            label="Todos"
          )

        v-flex.mb-25(xs12 sm3 md2)
          label.filter-label Estatus de localización
          v-select(
            :items="statusOptions"
            v-model="selectVictimStatus"
            target="#dropdown"
            solo
            clearable
            flat
            label="Todos"
          )

        v-flex(xs12 sm5 md3 px-4)
          label.filter-label  Año
          Slider

        v-flex.mb-25(xs12 sm4 md2)
          v-layout(row wrap)
            v-flex(xs6 sm6 md6 mx-6)
              label.filter-label Edad
              v-layout(row wrap)
                v-flex.age-filter(xs12 sm12 md12 mx-12)
                  p De
                  v-text-field(
                    v-model="selectFirstAge"
                    target="#dropdown"
                    solo
                    flat
                  )
            v-flex(xs6 sm6 md6 mx-6)
              label.filter-label &nbsp;
              v-layout(row wrap)
              v-flex.age-filter(xs12 sm12 md12 mx-12)
                p a
                v-text-field(
                  v-model="selectSecondAge"
                  target="#dropdown"
                  solo
                  flat
                )
          br
      hr.line

</template>

<script>
import Slider from "@/components/Slider";
import $data from "@/services/data.services.js";
import $geo from "@/services/geo.service.js";

export default {
  name: "Filters",
  components: {
    Slider
  },
  props: {},

  data() {
    return {
      states: ["Todos", ...$geo.getStates().sort()],
      sexOptions: ["Todos", "Hombre", "Mujer"],
      statusOptions: ["Todos","Localizado con vida",'Localizado sin vida',"Sin localizar"],
      addFilters: []
    };
  },
  computed: {
    reports() {
      return this.$store.state.reports;
    },
    path() {
      return this.$route.name;
    },
    period() {
      return this.$store.state.filters.period;
    },
    selectState: {
      get() {
        return this.$store.state.filters.state;
      },
      set(value) {
        this.$store.commit("setStateFilter", value);
        this.update();
      }
    },
    selectVictimStatus: {
      get() {
        return this.$store.state.filters.victimStatus;
      },
      set(value) {
        this.$store.commit("setVictimStatusFilter", value);
        this.update();
      }
    },
    selectFirstAge: {
      get() {
        return this.$store.state.filters.firstAge;
      },
      set(value) {
        this.$store.commit("setFirstAgeFilter", value);
        this.update();
      }
    },
    selectSecondAge: {
      get() {
        return this.$store.state.filters.secondAge;
      },
      set(value) {
        this.$store.commit("setSecondAgeFilter", value);
        this.update();
      }
    },
    selectSex: {
      get() {
        return this.$store.state.filters.sex;
      },
      set(value) {
        this.$store.commit("setSexFilter", value);
        this.update();
      }
    }
  },
  methods: {
    update: function() {
      $data.filterData();
    }
  },
  watch: {
    period: function() {
      this.update();
    }
  }
};
</script>

<style>
#filters {
  background-color: #f6f6f6;
}

.filter-label {
  text-transform: uppercase;
  font-family: "Open Sans", sans-serif;
  font-size: 10px;
  font-weight: 600;
  color: #747474;
  margin-bottom: 5px;
}

a.name:hover {
  color: #be3117;
}

.more .v-select__selections {
  display: none !important;
}

.v-text-field--box > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--solo > .v-input__control > .v-input__slot {
  min-height: auto !important;
  height: 40px;
  display: flex !important;
  align-items: center !important;
}

.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  border: 1px solid #979797 !important;
  box-shadow: none;
}

.material-icons {
  vertical-align: middle;
  margin-bottom: 4px;
}

.line {
  border: auto solid #979797;
  margin-top: 15px;
  margin-bottom: 15px;
}

#filters .v-label {
  font-size: 12px;
}

.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none !important;
}

.age-filter {
  display: flex;
  align-items: baseline;
}

.age-filter p {
  margin: 0px 10px;
  font-family: "Open Sans", sans-serif;
  color: #747474;
  font-size: 11px;
}

.label {
  font-size: 11px;
  color: #747474;
  font-weight: 900;
  font-family: "Open Sans", sans-serif;
}

.v-autocomplete {
  margin-bottom: 5px !important;
  margin-top: 2px !important;
  padding: 0px !important;
  border-radius: 2px;
}

.v-text-field__details {
  display: none;
}

.v-input__slot {
  background-color: #f6f6f6 !important;
  margin: 3px 0px;
  font-family: "Open Sans", sans-serif;
}

.v-select__slot {
  padding: 0px 10px;
}

.v-select__slot label {
  left: 15px !important;
  font-size: 12px;
  color: #747474 !important;
  font-weight: 600 !important;
}

.theme--light.v-select .v-select__selections {
  font-size: 12px;
  color: #747474 !important;
  font-weight: 600 !important;
}

.theme--light.v-input:not(.v-input--is-disabled) input,
.theme--light.v-input:not(.v-input--is-disabled) textarea {
  font-size: 12px;
  color: #747474 !important;
  font-weight: 600 !important;
}

.selector {
  max-width: 215px;
}

.mb-25 {
  margin-bottom: 25px;
}
</style>
